import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2026-07-01 19:18:34 +0200 (Wed, 01 Jul 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 164110 $
//  Purpose   : experimental openai interface components
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Button } from 'semantic-ui-react';
// ---Framework imports
import { Sel } from 'uix/registries';
import { strip, isNil } from 'ldash';
import { useDebounce, useSelector, useInView, useResettableState } from 'uix/hooks';
// ---Local imports
// ---Exports
const SeedButtons = ({ retrySeed, setRetrySeed, disabled, style, floated, defaultSeed, children })=>{
    let seed = isNil(retrySeed) ? defaultSeed || 0 : retrySeed;
    return /*#__PURE__*/ _jsxs(Button.Group, {
        basic: true,
        size: "mini",
        floated: floated,
        style: {
            ...style
        },
        children: [
            /*#__PURE__*/ _jsx(Button, {
                basic: true,
                disabled: !seed || disabled,
                onClick: ()=>Math.max(0, setRetrySeed(seed - 1)),
                icon: "arrow left"
            }),
            /*#__PURE__*/ _jsx(Button, {
                basic: true,
                content: seed
            }),
            /*#__PURE__*/ _jsx(Button, {
                basic: true,
                disabled: disabled,
                onClick: ()=>setRetrySeed(seed + 1),
                icon: "arrow right"
            }),
            children
        ]
    });
};
export const AiImage = ({ text, width = 256, height = 256, seed = 0 })=>{
    let [ref] = useInView({
        triggerOnce: true,
        rootMargin: '100%'
    });
    let apiurl = useSelector(Sel.apiurl);
    let [retrySeed, setRetrySeed] = useResettableState(null, [
        seed
    ]);
    if (retrySeed) {
        seed = retrySeed;
    }
    let [debouncedText] = useDebounce(text, 2000, {
        leading: true
    });
    let strippedPrompt = strip(debouncedText || '');
    let params = {
        prompt: strippedPrompt,
        seed
    };
    let src = apiurl.href('/api/openai/imagegen', params);
    return /*#__PURE__*/ _jsxs("div", {
        ref: ref,
        style: {
            float: 'right',
            marginTop: '20px',
            padding: '10px'
        },
        children: [
            /*#__PURE__*/ _jsx(SeedButtons, {
                floated: "right",
                retrySeed: retrySeed,
                setRetrySeed: setRetrySeed,
                defaultSeed: seed,
                style: {
                    marginTop: '-5px',
                    marginLeft: '-60px',
                    transform: 'scale(0.5)'
                }
            }),
            /*#__PURE__*/ _jsx("img", {
                src: src,
                style: {
                    width,
                    height,
                    float: 'right'
                },
                title: strippedPrompt,
                alt: strippedPrompt
            })
        ]
    });
};
